import RoundInterstitial from "@/components/game/RoundInterstitial";
import store from "@/store";

export default [
	{
		path: "rounds/begin",
		components: { gameSpace: RoundInterstitial },
		meta: { hideHeader: true, muteTogglePosition: 'route-based-positioning' },
	},
	{
		path: "rounds/:index(\\d+)",
		async beforeEnter(to, from, next) {
			await store.dispatch("game/rounds/activate", { index: parseInt(to.params.index) });
			next({ path: "/game/rounds/begin" });
		},
	},
	{
		path: "rounds/complete",
		async beforeEnter(to, from, next) {
			const path = store.getters["game/rounds/hasNextRound"] ? "/game/rounds/next" : "/game/complete";
			const { index } = store.state.game.rounds;
			await store.dispatch("game/rounds/active/applyBonus");
			await store.dispatch("game/plans/reset");
			await store.dispatch("global/analytics/trackPageView", { dp: `/round${index}` });
			next({ path });
		},
	},
	{
		path: "rounds/next",
		async beforeEnter(to, from, next) {
			const index = store.getters["game/rounds/nextIndex"];
			next({ path: `/game/rounds/${index}` });
		},
	},
];
